<div class="text-center p-gutter pb-8 header">
	<div class="container2">
		<h1 class="mt-2 display-1 mb-1" class="userWelcome">
			{{ 'GLOBAL.WELCOME_PERSON' | translate: { name: user?.name } }}
		</h1>
		<div class="flex flex-col md:flex-row gap-5">
			<div
				@fadeInUp
				fxLayout="row"
				fxLayoutAlign="center top"
				style="min-height: 600px; min-width: 600px">
				<div class="circleWrapper">
					<div class="assembly" *ngFor="let ps of processSteps; let i = index">
						<a href="{{ ps.link }}" target="_blank">
							<article
								style="--k: {{ i / processSteps.length }}; color: {{ ps.color }}">
								<h3>{{ ps.subtitle }}</h3>
								<img class="logo" src="{{ ps.icon }}" />
								<p>{{ ps.title }}</p>
							</article>
						</a>
					</div>
				</div>
				<div class="circleWrapperMobile">
					<mat-list>
						<mat-list-item *ngFor="let ps of processSteps" (click)="openLink(ps.link)">
							<img mat-list-icon matListItemAvatar src="{{ ps.icon }}" />
							<div mat-line matListItemTitle>{{ ps.title }}</div>
							<div mat-line matListItemLine>{{ ps.subtitle }}</div>
						</mat-list-item>
					</mat-list>
				</div>
			</div>

			<div class="flex flex-col flex-1">
				<div @fadeInUp *ngIf="dashboardMarkDownFromServer" class="card p-gutter relative">
					<showdown [value]="dashboardMarkDownFromServer"></showdown>
				</div>

				<div fxLayout="row" *ngIf="user.isAdmin" class="adminButtons">
					<button
						(click)="editMode = !editMode"
						color="primary"
						mat-flat-button
						type="button">
						<span>{{ (editMode ? 'BUTTON.CLOSE' : 'BUTTON.EDIT') | translate }}</span>
					</button>
					<div>&nbsp;&nbsp;</div>
					<button
						*ngIf="editMode"
						(click)="save()"
						color="primary"
						mat-flat-button
						type="button">
						<span>{{ 'BUTTON.SAVE' | translate }}</span>
					</button>
				</div>
				<div *ngIf="editMode">
					<textarea
						#textbox
						style="min-width: 500px; max-width: 100%; min-height: 400px; width: 100%"
						matInput
						[(ngModel)]="dashboardMarkDownFromServer"
						>{{ dashboardMarkDownFromServer }}</textarea
					>
					<!--<app-edit-markdown style="min-width:500px; max-width:100%; min-height:400px; width:100%;" [(model)]="dashboardMarkDownFromServer"></app-edit-markdown>-->
				</div>
			</div>
		</div>
	</div>
</div>
